module.exports = __webpack_public_path__ + "78c227ecccca575937f978de4de22519.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spinner.svg
// module id = 887
// module chunks = 0